function RegionMissing() {
  return (
    <blockquote className="p-4 bg-white">
      <h4 className="h6 mb-3">What It Means</h4>
      <p>No page regions or ARIA landmarks were found.</p>
      <h4 className="h6 mb-3">Why It Matters</h4>
      <p>Regions and ARIA landmarks identify significant page areas. Most web pages should have regions defined, particularly for the main content area.</p>
      <h4 className="h6 mb-3">What To Do</h4>
      <p>If the page has visual regions or significant page areas, ensure the regions are defined with header, nav, main, footer, etc. elements.</p>
    </blockquote>
  )
}

export default RegionMissing